
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The candidate's preferences in an ideal position.`}</p>
    <p><inlineCode parentName="p">{`ProactiveSourcing`}</inlineCode>{` candidates may have 0–1 position preferences.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;